<template>
    <div>
        <el-carousel :interval="4000" height="400px">
            <el-carousel-item v-for="item in imgList" :key="item.id">
                <router-link :to="item.routerPath">
                    <img :src="item.src" alt="" class="image">
                </router-link>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<style>
.image {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
        /*锁定图片的长宽比 */
}
</style>
<script>
export default {
    name: 'HomeImage',
    data() {
        return {
            imgList: [
            ]
        }
    },
  methods: {
    getPicView() {
      this.getRequest(baseUrl + '/pic/view/viewPic?picId=1').then(resp => {
        if (resp) {
        }
      });
    },
  },
  created() {
      let url = '/pic/list?picType=1';
      this.getRequest(url).then(resp => {
          if (resp) {
              if(resp.total > 0){
                  var _this = this;
                  resp.data.forEach(row => {
                      var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.picId;
                      _this.imgList.push(
                          {
                              src: imgUrl,
                              routerPath: eval('(' + row.picRouterPath + ')')
                          }
                      );
                  })
              }
          }
      });
  },


}
</script>
